




































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreateMenuButton from "./createmenubutton.vue";
import EditMenuButton from "./editmenubutton.vue";
import "@/assets/css/table.css";

class PageMenuButtonRequest extends PageRequest {
  keyword: string = "";
  parentId: number;
  menuType: number = 0;
}

@Component({
  components: { CreateMenuButton, EditMenuButton },
})
export default class MenuButton extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Number, default: 0 }) menuId: number;
  edit() {
    this.editModalShow = true;
  }

  pagerequest: PageMenuButtonRequest = new PageMenuButtonRequest();

  createModalShow: boolean = false;
  editModalShow: boolean = false;
  cancel() {
    this.$emit("input", false);
  }
  get list() {
    return this.$store.state.menubutton.list;
  }
  get loading() {
    return this.$store.state.menubutton.loading;
  }
  create() {
    this.createModalShow = true;
  }
  pageChange(page: number) {
    this.$store.commit("menubutton/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("menubutton/setPageSize", pagesize);
    this.getpage();
  }
  visibleChange(value: boolean) {
    if (value) {
      this.getpage();
    }
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "menubutton/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.menubutton.pageSize;
  }
  get totalCount() {
    return this.$store.state.menubutton.totalCount;
  }
  get currentPage() {
    return this.$store.state.menubutton.currentPage;
  }
  columns = [
    {
      type: "index",
      width: 60,
      align: "left",
      title: this.L("IndexNo"),
      fixed: "left",
    },
    {
      title: this.L("Name"),
      key: "displayName",
      width: 130,
    },
    {
      title: this.L("ButtonTag"),
      key: "tagName",
      width: 230,
    },
    {
      title: this.L("Action"),
      key: "action",
      width: 130,
    },
    {
      title: this.L("SortName"),
      key: "sortCode",
      width: 80,
    },
    {
      title: this.L("IsEnable"),
      key: "isEnable",
      width: 90,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.isEnable == 1 ? this.L("Actived") : this.L("NoActive")
        );
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 150,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.$store.commit("menubutton/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ),
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("DeleteConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "menubutton/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ),
        ]);
      },
    },
  ];
  async created() {
    this.pagerequest.menuType = 4;
  }
  @Watch("menuId")
  getitemId() {
    this.pagerequest.parentId = this.menuId;
  }
}
